import React from "react";

const Loading = () => {
  return <h4 className="text-muted text-center">Loading...</h4>;
};

export default Loading;
